export default "https://cdn-static.gokick.com/assets/31e0b9f53043906ee01608417204ccf2abfa2ab1/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";